import React from 'react';

const Biography = (props) => {
  const myBiography = (
    <div>
        <div className='item'>
            <p>{props.biography}</p>
        </div>
    </div>
  );
  return (
    <div className='title'>
      <i className='fa fa-address-card'></i>
      <h2>BIOGRAPHY</h2>
      {myBiography}
    </div>
  )
};

export default Biography;



// WEBPACK FOOTER //
// ./src/components/Biography.js